import moment from "moment";
import React, { useState } from "react";
import DateTimePicker from "../components/DateTimePicker";

const useDateFilter = () => {
  const [selectedFromDate, setSelectedFromDate] = useState(
    moment().startOf("month").toDate()
  );
  const [selectedToDate, setSelectedToDate] = useState(
    moment().endOf("month").toDate()
  );
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });
  const handleDateChangeFromDate = (date) => {
    setSelectedFromDate(date);
  };
  const handleDateChangeToDate = (date) => {
    setSelectedToDate(date);
  };
  const dateRangeFilterUi = () => {
    return (
      <div className="flex items-center justify-end gap-3 my-2">
        <div className="text-white">From</div>{" "}
        <DateTimePicker
          label="Start Date"
          selectedDate={selectedFromDate}
          onChange={handleDateChangeFromDate}
        />
        <div className="text-white">To</div>{" "}
        <DateTimePicker
          label="End Date"
          selectedDate={selectedToDate}
          onChange={handleDateChangeToDate}
        />
      </div>
    );
  };
  return {
    selectedFromDate,
    selectedToDate,
    handleDateChangeFromDate,
    handleDateChangeToDate,
    paginationModel,
    setPaginationModel,
    dateRangeFilterUi
  };
};

export default useDateFilter;
